export default function toCurrency(value = 0, locale = 'pl', currency = 'PLN') {
  return value.toLocaleString(locale, {
    style: 'currency',
    currency
  })
}
